module.exports = __webpack_public_path__ + "img/exchangeGoods.7dcb6361.png";